// API-kutsut kävijäpolulla: konfiguraation haku ja suostumuksen tallennus.
// apiBase on oman domainin/CDN-proxyn osoite (pelisääntö 1) — ei koskaan
// suoraan *.supabase.co.

import type { Choices, CmpConfig } from './types';
import { getVisitorId, storeConsentId } from './storage';

/** Yksinkertainen tekstihash (banneritekstien versiotodiste consent-riviin). */
export function hashText(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return hash.toString(16);
}

/**
 * Hakee bannerin konfiguraation: ensin julkaisussa kirjoitettu staattinen
 * /config/{domain}.json (ei tietokantakyselyä eikä cold startia, V1-T5),
 * ja jos sitä ei ole (esim. sivustoa ei ole vielä julkaistu uudella
 * julkaisupolulla), fallbackina get-banner-config-funktio.
 */
export function fetchBannerConfig(apiBase: string, domain: string): Promise<CmpConfig> {
  return fetch(apiBase + '/config/' + encodeURIComponent(domain) + '.json')
    .then(function (r) {
      if (!r.ok) throw new Error('static config unavailable (' + r.status + ')');
      return r.json();
    })
    .catch(function () {
      return fetch(apiBase + '/get-banner-config?domain=' + encodeURIComponent(domain)).then(function (r) {
        return r.json();
      });
    });
}

/**
 * Lähettää suostumustapahtuman (save-consent) ja tallentaa vastauksen
 * todistustunnuksen. Virheet vain logataan — banneri ei saa kaatua, vaikka
 * tallennus epäonnistuisi.
 */
export function sendConsent(
  apiBase: string,
  domain: string,
  config: CmpConfig,
  lang: string,
  choices: Choices,
  action: string,
  onDone?: (consentId: string) => void,
): void {
  const texts = config.texts[lang] || config.texts['fi'] || {};
  fetch(apiBase + '/save-consent', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      site_id: config.site_id,
      visitor_id: getVisitorId(),
      consent_action: action,
      consent_choices: choices,
      banner_config_version: config.version || 1,
      banner_language_shown: lang,
      page_url: location.href,
      user_agent_category: /Mobile/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
      full_banner_text_hash: hashText(JSON.stringify(texts)),
    }),
  })
    .then(function (r) {
      return r.json();
    })
    .then(function (data) {
      console.log('CMP: save-consent response', data);
      if (data && data.consent_id) {
        storeConsentId(domain, data.consent_id);
        if (onDone) onDone(data.consent_id);
      } else {
        console.warn('CMP: no consent_id in response', data);
      }
    })
    .catch(function (e) {
      console.warn('CMP: consent save failed', e);
    });
}
